import { render, staticRenderFns } from "./_formSection.vue?vue&type=template&id=7a274fc8&scoped=true&"
import script from "./_formSection.vue?vue&type=script&lang=js&"
export * from "./_formSection.vue?vue&type=script&lang=js&"
import style0 from "./_formSection.vue?vue&type=style&index=0&id=7a274fc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a274fc8",
  null
  
)

export default component.exports